<template>
  <div>
    <BreadCrumd
      :title="'Formations'"
      :description="'Liste des formations disponibles'"
    />
    <div class="mt-2 mb-4">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <multiselect
            v-model="selectedHeaders"
            :options="headers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par colonne"
            label="text"
            track-by="text"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Colonnes' : 'Colonne' }}
              </span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable :headers="selectedHeaders" ref="datatable" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
export default {
  data() {
    return {
      title: 'Formations disponibles',
      selectedHeaders: [],
      headers: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Intitulé',
          align: 'start',
          sortable: true,
          value: 'intitule',
        },
        {
          text: 'Durée (heures)',
          align: 'start',
          sortable: true,
          value: 'duree',
        },
        {
          text: 'Nbre de places disponibles',
          align: 'start',
          sortable: true,
          value: 'nbre_place',
        },
        {
          text: 'Session confirmée',
          align: 'start',
          sortable: true,
          value: 'nbre_session',
        },
        {
          text: 'Statut',
          align: 'start',
          sortable: false,
          value: 'statut',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
  },
  methods: {},
};
</script>

<style scoped></style>
